import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// URL-safe slug — handles Turkish and other special characters
// "Türkiye" → "turkiye", "İstanbul" → "istanbul", "New York" → "new-york"
export function slugify(str) {
  return (str ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')  // strip combining diacritics
    .replace(/[İ]/g, 'i')            // Turkish capital İ
    .replace(/[ı]/g, 'i')            // Turkish ı
    .replace(/[ğĞ]/g, 'g')
    .replace(/[şŞ]/g, 's')
    .replace(/[çÇ]/g, 'c')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
}
